// Moved from `src/hooks/mutation/useMutateExtendReverseTrial.ts` (now a
// delegate) at D2, ARCFE-972. Same severance as its revert sibling; see that
// file's header for why the invalidators cross as a port rather than an
// import.

import { useMutation } from '@tanstack/react-query';
import { extendReverseTrial } from '../api/trials';

export type UseMutateExtendReverseTrialProps = {
  /**
   * Fires where the two invalidators + the success toast fired, carrying the
   * granted `hours` because the legacy copy pluralises on it.
   */
  onExtendSuccess?: (hours: number) => void;
  /** Fires where the destructive toast fired. */
  onExtendError?: (error: unknown) => void;
};

/**
 * POST /user/extend-reverse-trial.
 *
 * NOTE on the error port: the legacy hook toasted ONLY for an `AxiosError`
 * and silently swallowed anything else. That asymmetry is preserved by
 * keeping the `instanceof AxiosError` test in the delegate — this hook fires
 * the port for every error, and the delegate decides. Moving the test in here
 * would have meant naming axios in the package surface; moving it away
 * silently would have started toasting on errors that never toasted before.
 */
export function useMutateExtendReverseTrial({
  onExtendSuccess,
  onExtendError,
}: UseMutateExtendReverseTrialProps = {}) {
  return useMutation({
    mutationFn: async (hours: number) => {
      await extendReverseTrial(hours);
    },
    onSuccess: (_, hours) => {
      onExtendSuccess?.(hours);
    },
    onError: (error) => {
      onExtendError?.(error);
    },
  });
}
